export default "__VITE_ASSET__BFxw62kE__"